<template lang="pug">
//- 下拉框的模糊搜索组件
.search-main
  div.addTeachers
    //- 这里是外框的上半部分
    div.inputBlock(@click="isOpen = !isOpen")
      div.tagBox
        //- 最后一步,贴tag
        div
          //- span.noSelect(v-if="tagSelectCodes.length === 0") 请选择
          Tag.selectSearchTag(v-for="(item, index) in tagSelectCodes" closable :key="index" @on-close="delSelect(index)") {{tagSelectNames[index]}}
          input.selectSearch(
            :style='{width:getInputWidths}'
            v-model='selectInput'
            ref='selectSearch'
            :placeholder='`${tagSelectCodes.length === 0?"请选择":"请输入"}`'
            )
      Icon.openDown(:type="isOpen === true?'ios-arrow-up':'ios-arrow-down'" )
    //- 这里是点开的部分
    div.teachersList(v-if="isOpen === true")
      ul.dropDownList
        li.listChild(@click="allIn()" v-if='optionList.length !== 0' style="border-bottom:1px solid #F3F3F4")
          span.ListName(:class="allInCheck === true? 'checkThisTeacher':''") 全选
          Icon.current(:class="allInCheck === true? 'checkThisTeacher':''" type="md-checkmark")
        li.listChild(v-if='optionList.length === 0' style="border-bottom:1px solid #F3F3F4")
          span.ListName(:class="allInCheck === true? 'checkThisTeacher':''") 暂无数据
        //- 如果不是code和name，这里要处理一下
        li.listChild(v-for="item in optionList" @click="chooseShareTeacher(item)" v-if="typeIsUser(item[optionValue]) ")
          span.ListName(:class="tagSelectCodes.indexOf(item[optionValue]) === -1 ? '' : 'checkThisTeacher' ") {{item[optionLabel]}}
          Icon.current(:class="tagSelectCodes.indexOf(item[optionValue]) === -1 ? '' : 'checkThisTeacher' " type="md-checkmark")
  div.mask(v-show="isOpen === true" @click="closeInput()")
</template>

<script>
// import iSelectSearch from "@/components/common/iSelectSearch.vue"; /** 自定义下拉框 */

export default {
  props: {
    /** 选项列表 */
    optionList: {
      type: Array,
      require: true,
      default: () => { return []; }
    },
    /** 配置项——要结合其他情况一起处理，目前只是user，所以没细处理 */
    option: {
      type: Object,
      default: () => {
        return {
          label: "name",
          value: "code"
        };
      }
    },
    /** 是否需要单独处理admin */
    exceptAdmin: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    typeIsUser() {
      // const { exceptAdmin: isAdmin, optionValue: code, optionLabel: name } = this;
      return (key) => {
        if (this.exceptAdmin) {
          // 需要判断admin
          return key !== this.$role.code;
        }
          return true;
      };
    }
  },
  data() {
    return {
      isOpen: false, /** select展开状态 */
      allInCheck: false, /** 全选 */
      tagSelectCodes: [], /** tag对应code。也是当前选中code */
      tagSelectNames: [], /** tag对应name */
      optionLabel: "name", /** option */
      optionValue: "code", /** option */
      selectInput: "", /** 选择框的输入框 */
      getInputWidths: "100%" /** input的宽度 */
    };
  },
  methods: {
    /** 给父级返回值 */
    notifyParent() {
      const { tagSelectCodes: selectKeys, tagSelectNames: selectNames, selectInput } = this;
      this.$emit("change", { selectKeys, selectNames, selectInput });
    },
    /** 更新宽度 */
    changeInputWidth(refName = "selectSearch", tagName = "selectSearchTag") {
      const { tagSelectCodes } = this;
      /** 有tag，返回处理后的宽度 */
      if (tagSelectCodes.length) {
        const currentNode = this.$refs[refName];
        if (currentNode) {
          const parentNode = currentNode.parentNode;
          if (parentNode) {
            let w = 0;
            this.$nextTick(() => {
              const nodeList = document.querySelectorAll(`.${tagName}`);
              Array.from(nodeList).forEach(ele => {
                w += ele.clientWidth;
                w += 10; // 边距4px
                if (w > parentNode.clientWidth) {
                  w = ele.clientWidth;
                  w += 10;
                }
              });
              // console.log(w, "tag", parentNode.clientWidth, "width");
              if (parentNode.clientWidth <= w + 30) {
                // console.log("改换行了");
                this.getInputWidths = "100%";
              } else {
                this.getInputWidths = `${parentNode.clientWidth - w}px`;
              }
            });
          }
        }
      } else {
        /** 如果没有tag，返回100% */
        this.getInputWidths = "100%";
      }
    },
    /** 点击选项 */
    chooseShareTeacher(item) {
      const { optionValue: code, optionLabel: name } = this;
      if (this.tagSelectCodes.indexOf(item[code]) === -1) {
        this.tagSelectCodes.push(item[code]);
        this.tagSelectNames.push(item[name]);
        if (this.tagSelectCodes.length === this.optionList.length - 1) {
          this.allInCheck = true;
        }
      } else {
        this.tagSelectCodes.splice(this.tagSelectCodes.indexOf(item[code]), 1);
        this.tagSelectNames.splice(this.tagSelectCodes.indexOf(item[code]), 1);
        this.allInCheck = false;
      }
      this.notifyParent();
    },
    /** 全选 */
    allIn() {
      // 如果不是code和name， 这里要处理一下
      const { optionValue: code, optionLabel: name } = this;
      this.tagSelectCodes = [];
      this.tagSelectNames = [];
      this.allInCheck = !this.allInCheck;
      if (this.allInCheck === true) {
        this.optionList.forEach(res => {
          if (res.code !== this.$role.code) {
            this.tagSelectCodes.push(res[code]);
            this.tagSelectNames.push(res[name]);
          }
        });
      } else {
        this.tagSelectCodes = [];
        this.tagSelectNames = [];
      }
      this.notifyParent();
    },
    /** 删除tag */
    delSelect(index) {
      this.tagSelectCodes.splice(index, 1);
      this.tagSelectNames.splice(index, 1);
      this.allInCheck = false;
      this.notifyParent();
    },
    /** 关闭选择框 */
    closeInput() {
      this.isOpen = false;
    },
    /** 预设重置 */
    initValue() {
      this.isOpen = false;
      this.allInCheck = false;
      this.tagSelectCodes = [];
      this.tagSelectNames = [];
    },
    /** 选项重置 */
    initOption() {
      this.optionValue = this.option.value;
      this.optionLabel = this.option.label;
    }
  },
  mounted() {
    this.initOption();
    this.selectInput = "";
  },
  watch: {
    /** 当输入框变化，通知父组件更新optionList */
    selectInput: {
      handler(newVal) {
        // console.log(newVal, "通知父组件，输入框变了");
        this.$emit("inputChange", newVal);
      }
    },
    /** 当选中值变化，重新计算宽度。并且把值返回父组件 */
    tagSelectCodes: {
      handler() {
        this.changeInputWidth(); /** 重新计算input宽度 */
        this.notifyParent(); /** 返回新的rowKeys */
      },
      deep: true
    }
  }
};
</script>

<style lang="stylus" scoped>
.search-main
  .addTeachers
    // width 488px
    border 1px solid #dcdee2
    border-radius 4px
    position relative
    z-index 1053
    // 这里是外框的上半部分
    .inputBlock
      .tagBox
        min-height 32px
        padding 0 24px 0 4px
        display block
        cursor pointer
        div
          position: relative;
          .noSelect
            display block
            height 30px
            line-height 30px
            color #c5c8ce
            font-size 14px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            padding-left 4px
            padding-right 22px
          .selectSearch
            border none
            // background: red
            width 100%
            height 32px
            display inline-block
            &:focus
              outline none // border
      .openDown
        position absolute
        top 50%
        right 8px
        line-height 1
        -webkit-transform translateY(-50%)
        transform translateY(-50%)
        font-size 14px
        color #808695
        -webkit-transition all 0.2s ease-in-out
        transition all 0.2s ease-in-out
        cursor pointer
    // 这里是选择教师部分
    .teachersList
      position absolute !important
      min-width 488px
      width inherit
      max-height 200px
      overflow auto
      margin 5px 0
      padding 5px 0
      background-color #fff
      -webkit-box-sizing border-box
      box-sizing border-box
      border-radius 4px
      -webkit-box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
      box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
      position absolute
      z-index 900
      .dropDownList
        min-width 100%
        list-style none
        box-sizing border-box
        margin 0
        padding 0
        -webkit-tap-highlight-color rgba(0, 0, 0, 0)
        .listChild
          position relative
          margin 0
          line-height normal
          padding 7px 16px
          clear both
          color #515a6e
          font-size 14px !important
          white-space nowrap
          list-style none
          cursor pointer
          -webkit-transition background 0.2s ease-in-out
          transition background 0.2s ease-in-out
          .ivu-icon-md-checkmark
            float right
            display none
        .listChild:hover
          background #F3F3F3
        .checkThisTeacher
          color rgba(45, 140, 240, 0.9)
          display initial !important
  .mask
    position fixed
    overflow auto
    top 0
    right 0
    bottom 0
    left 0
    z-index 1052
    outline 0
</style>
